

import { postDict } from "../api/api";
import { chooseObj, datePickerObj, inputObj, pickerObj } from "utils/getObjs";

/** 失业登记 */
const delclarationForm= [
    inputObj('姓名', "FNAME", true, true),
    inputObj('性别', "FSEX", true, true),
    datePickerObj('出生日期', "FBIRTH", true),
    pickerObj('民族', 'FNATION', true),
    pickerObj('政治面貌', 'FPOLSTAT'),
    pickerObj('学历', 'FEDUBACK', true),
    pickerObj('健康状况', 'FHealState', true),
    inputObj('证件类型', "FCERCAT", true, true),
    inputObj('证件号码', "FIDNum", false, true),
    datePickerObj('毕业年月', 'FGRADTIME'),
    inputObj('毕业院校', "FGRADSCH"),
    inputObj('专业', "FPROFESSION"),
    pickerObj('户口性质', 'FREGIPERM', true),
    {
      ...chooseObj('失业登记地类型', 'FREGISTYPE', true),
      option: [[
        { label: '户籍地址', value: 1 },
        { label: '常住地址', value: 2 }
      ]]
    },
    pickerObj('户籍地址', 'nation', true, true),
    inputObj('户籍详细地址', "FRESIDDETA", true),
    pickerObj('常住地址', 'permanent', true, true),
    inputObj('常住详细地址', "FPERDETA", true),
  ];

// export const 

const phoneForm = [
  inputObj('手机号码', "FPhoNum", true),
  inputObj('电子邮箱', "FEMAIL"),
  inputObj('固定电话', "FPHO"),
  inputObj('其他联系方式', "FOTHER"),
]

// 失业信息
const loseInfo = [
  datePickerObj('失业时间', 'FUNEMPTIME', true),
  inputObj('失业登记日期', "FREGISTERDATE", true, true),
  pickerObj('失业原因', 'FUNEMPREA', true),
  // chooseObj('是否申领失业保险金', 'FISAPPLYUNEMP', true),
  chooseObj('是否申领就业创业电子证', 'FISAPPLYEMPCARD', true),
  inputObj('原工作单位名称', "FORGNAME"),
  pickerObj('原工种', 'FWORKTYPE'),
  // inputObj('在闽工龄', "FWORKTIME"),
  inputObj('审核资料', 'FAPPLYFILE')
]

// 职业(工种)资格
const skillInfo = [
  {
    infoType: 'manyCascade',
    tableName: 'FJobLevel',
    label: '职业(工种)资格',
    pickerTitle: '请选择',
    option: [
      pickerObj('职业(工种)资格', 'FPROQUALITY'),
      pickerObj('职业资格等级', 'FPROQUALITYLEVEL'),
    ],
    placeholder: '请选择',
    api: postDict,
    count: [0, 1, 2],
  },

]
// 专业技术职务
const postInfos = [
  {
    infoType: 'manyCascade',
    tableName: 'FProTech',
    label: '等级',
    option: [
      pickerObj('专业技术职务', 'FPROTECH'),
      pickerObj('专业技术等级', 'FPROTECHLEVEL'),
    ],
    api: postDict,
    count: [0, 1, 2],
  },
]
// 求职意向
const jobWanted = [
  {
    infoType: 'manyCascade',
    tableName: 'FJobIntent',
    label: '求职',
    option: [
      pickerObj('意向岗位', 'FJOBINTEN'),
      pickerObj('求职意向地', 'place'),
      pickerObj('期望薪资', 'FSALARYPACK'),
    ],
    api: postDict,
    count: [0, 1, 2],
  },
]

export const declarationPage1 = [
  { title: '我要就业', arr: delclarationForm },
  { title: '联系方式', arr: phoneForm },
  { title: '职业(工种)资格', arr: skillInfo },
  { title: '专业技术职务', arr: postInfos }
]
export const declarationPage2 = [
  { title: '失业信息', arr: loseInfo }
]
export const declarationPage3 = [
  { title: '求职意向', arr: jobWanted }
]
